import {
    Configuration,
    InvoiceApi,
    PlanApi,
    SubscriptionApi,
    TransactionApi,
    UserApi,
    LegacySubscriptionApi,
    CreditApi,
} from '@videoblocks/subscription-service-client';

const basePath = process.env.SUBSCRIPTION_SERVICE_HOST ?? 'http://localhost:4020';
export const subscriptionServiceConfig = new Configuration({ basePath });

export const userApi = new UserApi(subscriptionServiceConfig);
export const transactionApi = new TransactionApi(subscriptionServiceConfig);
export const planApi = new PlanApi(subscriptionServiceConfig);
export const subscriptionApi = new SubscriptionApi(subscriptionServiceConfig);
export const invoiceApi = new InvoiceApi(subscriptionServiceConfig);
export const legacySubscriptionApi = new LegacySubscriptionApi(subscriptionServiceConfig);
export const creditApi = new CreditApi(subscriptionServiceConfig);
